import { BaseProduct } from '../types';
import { getVariantOptionKeyForMaterialTypeDay } from './materialTypeDay';
import { getVariantOptionKeyForMaterialTypeNight } from './materialTypeNight';

type ProductHasVariantWithMaterialTypeDayNight = (
  materialType: string,
) => (product: BaseProduct) => boolean;

export const productHasVariantWithMaterialTypeDayNight: ProductHasVariantWithMaterialTypeDayNight = materialType => product => {
  const materialKey = getVariantOptionKeyForMaterialTypeDay(product);

  if (materialKey === null) return false;

  return product.variants.some(
    variant => variant[materialKey] === materialType,
  );
};
